import { Component, OnInit } from '@angular/core';
import { GlobalesService } from 'src/app/servicios/globales.service';
import { ObtenerDatosService } from '../../../../servicios/datos/obtener-datos/obtener-datos.service';

import { ThemeService } from '../../../../theme/theme.service';

@Component({
  selector: 'app-pregunta-elementos-apoyo',
  templateUrl: './pregunta-elementos-apoyo.component.html',
  styleUrls: ['./pregunta-elementos-apoyo.component.scss']
})
export class PreguntaElementosApoyoComponent implements OnInit {
  config:any = {};
  Search = "";

  constructor(public _globalService: GlobalesService,public readonly _obtenerDatosService: ObtenerDatosService,public themeService: ThemeService,) { }

  ngOnInit(): void {
    this._globalService.searchItem.subscribe(data =>{
      if(data == null) return;
      this.Search = data
    });
    this._obtenerDatosService.configSubject.subscribe(data =>{
      if (data != null) this.config = data;
    });
  }

}
